import { useQuery } from "@tanstack/react-query";
import { CartOrders, CartApprove, CartReject } from "../services/services";
import ResponsiveDataList from "../components/ResponsiveDataList/ResponsiveDataList";
import { useEffect, useState } from "react";
import PersianDate from "../components/PersianDate/PersianDate";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import TextField from "../components/Textfield/TextField";
import CloseRedIconSvg from "../svg/CloseRedIconSvg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { GetUnixDate } from "../components/GetUnixDate/GetUnixDate";
import { SelectCustom } from "../components/SelectCustom/SelectCustom";
import { CampaignonvertUnixToGregorian } from "../components/ConvertUnixToGregorian/ConvertUnixToGregorian";
import { Dialog } from "primereact/dialog";
import TextareaField from "../components/TextareaField/TextareaField";
import { moreSvg } from "../svg/more";
import { Link } from "react-router-dom";
import { useResponsivePageSize } from "../hook/useResponsivePageSize";
import useSyncPageSize from "../hook/useSyncPageSize";
import { URLs } from "../constants/urls";
import * as XLSX from "xlsx";
import Loading from "../components/Loading/Loading";

const Campaign = () => {
  const [modalDontSend, setModalDontSend] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [messageContent, setMessageContent] = useState("");
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedOrdersList, setSelectedOrdersList] = useState([]);
  const [isBulkReject, setIsBulkReject] = useState(false);

  const pageSize = useResponsivePageSize({ defaultSmall: 100 });
  const location = useLocation();
  const history = useHistory();

  const getFiltersFromUrl = () => {
    const parsed = queryString.parse(location.search);
    const initialPageSize = parsed.pageSize
      ? Number(parsed.pageSize)
      : pageSize;
    return {
      OrderId: parsed.OrderId ?? undefined,
      Name: parsed.Name ?? "",
      From: parsed.From !== undefined ? new Date(Number(parsed.From)) : "",
      To: parsed.To !== undefined ? new Date(Number(parsed.To)) : "",
      PhoneNumber: parsed.PhoneNumber ?? "",
      ProductCategoryType:
        parsed.ProductCategoryType !== undefined
          ? Number(parsed.ProductCategoryType)
          : 1,
      Status: parsed.Status !== undefined ? Number(parsed.Status) : 0,
      OrderBy: parsed.OrderBy ?? "",
      pageNumber: Number(parsed.pageNumber) || 1,
      pageSize: initialPageSize,
      IsAscending:
        parsed.IsAscending === "true"
          ? true
          : parsed.IsAscending === "false"
          ? false
          : undefined,
    };
  };

  const [filters, setFilters] = useState(getFiltersFromUrl());
  const [pageSizeState, setPageSizeState] = useState(filters.pageSize);
  const [tempFilters, setTempFilters] = useState(filters);
  useSyncPageSize(filters, setFilters, pageSize);

  useEffect(() => {
    const query = queryString.stringify(filters, {
      skipNull: true,
      skipEmptyString: true,
    });
    history.replace({ search: `?${query}` });
  }, [filters, history]);

  const { data: userCampaign, refetch } = useQuery({
    queryKey: ["CartOrders", filters],
    queryFn: () =>
      CartOrders({
        OrderId: filters.OrderId,
        Name: filters.Name,
        From: filters.From ? CampaignonvertUnixToGregorian(filters.From) : null,
        To: filters.To ? CampaignonvertUnixToGregorian(filters.To) : null,
        PhoneNumber: filters.PhoneNumber,
        ProductCategoryType: filters.ProductCategoryType,
        Status: filters.Status,
        OrderBy: filters.OrderBy,
        IsAscending: filters.IsAscending,
        pageNumber: filters.pageNumber,
        pageSize: filters.pageSize,
      }),
    select: (res) => res,
    staleTime: 60 * 60000,
    retry: false,
    enabled: true,
  });

  const formatAddress = (addr) => {
    if (!addr) return "";
    if (typeof addr === "string") return addr;
    const { provinceName, cityName, addressDetails, postalCode } = addr;
    return [
      [provinceName, cityName].filter(Boolean).join("، "),
      addressDetails,
      postalCode && postalCode.trim() ? `کدپستی: ${postalCode}` : null,
    ]
      .filter(Boolean)
      .join(" | ");
  };

  const handleSearch = () => {
    setFilters(tempFilters);
    refetch();
  };

  const handleChange = (key, value) => {
    setTempFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const listItemType = [
    { label: " همه موارد ", value: null },
    { label: " نقدی", value: 1 },
    { label: " هدیه", value: 3 },
  ];

  const listState = [
    { label: " همه موارد ", value: null },
    { label: "در حال انتظار ", value: 0 },
    { label: "تایید ", value: 1 },
    { label: " رد", value: 2 },
  ];

  const orderByOptions = [
    { label: "تاریخ سفارش", value: "creationTime" },
    { label: " سکه ", value: "totalAmount" },
  ];

  const sortOrderBy = [
    { label: "بیشترین", value: "false" },
    { label: "کمترین", value: "true" },
  ];

  const stateFormatter = (value) => {
    if (value === 1) {
      return (
        <div
          style={{
            color: "#fff",
            background: "#5ca03cad",
            display: "flex",
            justifyContent: "center",
            width: "70%",
            borderRadius: "10px",
            padding: "0 4px",
          }}
        >
          تایید شده
        </div>
      );
    }
    if (value === 2) {
      return (
        <div
          style={{
            color: "#fff",
            background: "#dd2c2cad",
            display: "flex",
            justifyContent: "center",
            width: "70%",
            borderRadius: "10px",
            padding: "0 4px",
          }}
        >
          تایید نشده
        </div>
      );
    }
    return (
      <div
        style={{
          color: "#fff",
          background: "#e7a151",
          display: "flex",
          justifyContent: "center",
          width: "70%",
          borderRadius: "10px",
          padding: "0 4px",
        }}
      >
        در حال انتظار
      </div>
    );
  };

  const stateFormatterExcel = (value) => {
    if (value === 1) return "تایید شده";
    if (value === 2) return "تایید نشده";
    if (value === 0) return "در حال انتظار";
    return "";
  };

  // اکشن تکی
  const approveOrder = async (orderId) => {
    await CartApprove({
      orderIds: [orderId],
    });
    refetch();
    closeDetails();
  };

  const rejectOrder = async (orderId, reason) => {
    await CartReject({
      orderIds: [orderId],
      reason: reason || "",
    });
    refetch();
    closeDetails();
  };

  // اکشن گروهی
  const handleBulkApprove = async () => {
    if (!selectedOrdersList.length) return;

    await CartApprove({
      orderIds: selectedOrdersList,
    });

    setSelectedOrders([]);
    setSelectedOrdersList([]);
    refetch();
  };

  const handleBulkReject = () => {
    if (!selectedOrdersList.length) return;
    setIsBulkReject(true);
    setModalDontSend(true);
    setMessageContent("");
    setSelectedRowData(null);
  };

  const openDetails = (row) => {
    setSelectedOrder(row);
    setDetailsOpen(true);
  };

  const closeDetails = () => {
    setDetailsOpen(false);
    setSelectedOrder(null);
    setRejectReason("");
  };

  // ستون‌ها + ستون عملیات
  const columnsWithoutActions = [
    {
      columnKey: "rowIndex",
      header: "ردیف",
      body: (row, opt) =>
        (filters.pageNumber - 1) * filters.pageSize + opt.rowIndex + 1,
      style: { textAlign: "center", width: "4rem" },
    },
    {
      columnKey: "id",
      field: "id",
      header: "شناسه",
      style: { textAlign: "right" },
    },
    {
      columnKey: "name",
      header: "نام",
      body: (r) => <span>{r?.userInfo?.name}</span>,
      style: { textAlign: "right" },
    },
    {
      columnKey: "creationTime",
      header: "تاریخ درخواست",
      body: (r) => <PersianDate date={r.creationTime} />,
      style: { textAlign: "right" },
    },
    ...(filters?.ProductCategoryType === 3 ||
    filters?.ProductCategoryType == null
      ? [
          {
            columnKey: "address",
            header: "آدرس",
            body: (r) => (
              <div
                title={formatAddress(r.address)}
                style={{
                  maxWidth: "12rem",
                }}
              >
                {formatAddress(r.address)} | پلاک :{" "}
                {formatAddress(r?.address?.number)} | واحد :
                {formatAddress(r?.address?.unit)}
              </div>
            ),
            style: { textAlign: "right" },
          },
        ]
      : []),
    {
      columnKey: "phone",
      header: "موبایل",
      body: (rowData) => <span>{rowData?.userInfo?.phoneNumber}</span>,
      style: { textAlign: "right" },
    },
    ...(filters?.ProductCategoryType !== 3
      ? [
          {
            columnKey: "iban",
            field: "ibanCode",
            header: "کدشبا",
            style: { textAlign: "right" },
          },
        ]
      : []),
    {
      columnKey: "status",
      header: "وضعیت",
      body: (r) => <span>{stateFormatter(r.status)}</span>,
      style: { textAlign: "right" },
    },
    {
      columnKey: "totalAmount",
      field: "totalAmount",
      header: "سکه",
      style: { textAlign: "right" },
    },
    ...(filters?.ProductCategoryType !== 3
      ? [
          {
            columnKey: "coinToRial",
            header: "سکه به ریال",
            body: (rowData) => <span>{rowData?.totalAmount * 10000}</span>,
            style: { textAlign: "right" },
          },
        ]
      : []),
    {
      columnKey: "actions",
      header: "عملیات",
      isActions: true,
      body: (rowData) => (
        <div
          style={{
            display: "flex",
            gap: 8,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {rowData.status === 0 && (
            <button
              type="button"
              style={{
                width: "60px",
                borderRadius: 6,
                border: "none",
                background: "rgba(39,138,60,.9)",
                color: "#fff",
                fontSize: 12,
              }}
              onClick={(e) => {
                e.stopPropagation();
                approveOrder(rowData.id);
              }}
            >
              تایید
            </button>
          )}
          {rowData.status === 0 && (
            <button
              type="button"
              style={{
                width: "60px",
                borderRadius: 6,
                border: "none",
                background: "rgba(253,76,76,.9)",
                color: "#fff",
                fontSize: 12,
              }}
              onClick={(e) => {
                e.stopPropagation();
                setIsBulkReject(false);
                setSelectedRowData(rowData);
                setMessageContent("");
                setModalDontSend(true);
              }}
            >
              رد
            </button>
          )}
        </div>
      ),
      style: { textAlign: "center", minWidth: "110px" },
    },
  ];

  // فقط ستون‌هایی که اکشن نیستند کلیک‌بل هستند
  const clickableColumns = columnsWithoutActions.map((col) => {
    if (col.isActions) return col;
    return {
      ...col,
      body: (rowData, options) => (
        <div style={{ cursor: "pointer" }} onClick={() => openDetails(rowData)}>
          {col.body ? col.body(rowData, options) : rowData[col.field]}
        </div>
      ),
    };
  });

  const itemTemplate = (item) => (
    <div
      key={item.Id}
      className="rounded shadow-sm mb-3 p-3"
      style={{ backgroundColor: "#f9f9f9", border: "1px solid #eee" }}
    >
      <div className="mb-2 d-flex justify-content-between">
        <span className="text-muted">شناسه:</span>
        <span className="fw-bold farsi-monospace-digit">{item.id}</span>
      </div>
      <hr />
      <div className="mb-3">
        <strong>نام:</strong> {item?.userInfo?.name}
      </div>
      <div className="mb-3">
        <strong>تاریخ درخواست:</strong> <PersianDate date={item.creationTime} />
      </div>
      <div className="mb-3">
        <strong>آدرس:</strong> {formatAddress(item.address)} | پلاک :{" "}
        {formatAddress(item?.address?.number)} | واحد :
        {formatAddress(item?.address?.unit)}
      </div>
      <div className="mb-3">
        <strong>موبایل:</strong> {item?.userInfo?.phoneNumber}
      </div>
      <div className="mb-3">
        <strong>کدشبا:</strong> {item.ibanCode}
      </div>
      <div className="d-flex mb-3">
        <strong>وضعیت:</strong>
        {stateFormatter(item.status)}
      </div>
      <div className="d-flex justify-content-between mt-4 mb-3">
        <Link
          className=" mx-1"
          to={URLs.USER_INFORMATION + `?userId=${item.id}`}
        >
          {moreSvg()}
        </Link>
        {item.status === 0 && (
          <button
            style={{
              color: "#ffff",
              background: "rgba(39, 138, 60, 0.92)",
              border: "0px",
              width: "90px",
              height: "30px",
              borderRadius: "8px",
              padding: "2px",
            }}
            onClick={() =>
              CartApprove({
                orderIds: [item.id],
              }).then(() => refetch())
            }
          >
            تایید
          </button>
        )}
        {item.status === 0 && (
          <button
            style={{
              color: "#ffff",
              background: "rgb(253, 76, 76, 0.92)",
              border: "0px",
              width: "90px",
              height: "30px",
              borderRadius: "8px",
              padding: "2px",
            }}
            onClick={() => {
              CartReject({
                orderIds: [item.id],
                reason: rejectReason || "",
              });
              refetch();
              closeDetails();
            }}
          >
            رد
          </button>
        )}
      </div>
    </div>
  );

  const formatNumber = (n) =>
    typeof n === "number" ? n.toLocaleString("fa-IR") : n ?? "";

  const statusBadge = (status) => {
    const map = {
      0: { text: "در حال انتظار", bg: "rgba(255,193,7,.15)", color: "#856404" },
      1: { text: "تایید شده", bg: "rgba(40,167,69,.15)", color: "#155724" },
      2: { text: "تایید نشده", bg: "rgba(220,53,69,.15)", color: "#721c24" },
    };
    const it = map[status] ?? map[0];
    return (
      <span
        style={{
          background: it.bg,
          color: it.color,
          borderRadius: 8,
          padding: "2px 8px",
          fontSize: 12,
          whiteSpace: "nowrap",
        }}
      >
        {it.text}
      </span>
    );
  };

  const exportToExcel = () => {
    const orders = userCampaign?.items ?? [];
    if (!orders.length) return;

    const productCategoryType = filters?.ProductCategoryType;

    // تعیین اینکه ستون وسط چی باشه و هدرش چی نوشته بشه
    const addressOrIbanHeader =
      productCategoryType === 3
        ? "آدرس"
        : productCategoryType === 1
        ? "شبا"
        : "آدرس";

    const isCategory1 = productCategoryType === 1;

    const rows = orders.flatMap((order) => {
      const base = {
        id: order?.id ?? "",
        name: order?.userInfo?.name ?? "",
        createdAt: order?.creationTime
          ? new Date(order.creationTime).toLocaleString("fa-IR")
          : "",
        addressOrIban:
          productCategoryType === 3 || productCategoryType == null
            ? `${formatAddress(order?.address)} | پلاک: ${formatAddress(
                order?.address?.number
              )} | واحد: ${formatAddress(order?.address?.unit)}`
            : order?.ibanCode ?? "",
        phone: order?.userInfo?.phoneNumber ?? "",
        status: stateFormatterExcel(order?.status) ?? "",
        totalAmount: order?.totalAmount ?? "",
      };

      if (order.items && order.items.length > 0) {
        return order.items.map((item) => {
          const coinCount = item.purchasedPrice * item.quantity;

          const row = {
            شناسه: base.id,
            نام: base.name,
            "تاریخ درخواست": base.createdAt,
            "نام هدیه": item.productName ?? "",
            "تعداد هدیه": item.quantity ?? "",
            [addressOrIbanHeader]: base.addressOrIban,
            "شماره موبایل": base.phone,
            وضعیت: base.status,
            "مجموع تعداد سکه ها": coinCount,
          };

          if (isCategory1) {
            row["تبدیل سکه به ریال"] = coinCount * 10000;
          }

          return row;
        });
      }

      const emptyRow = {
        شناسه: base.id,
        نام: base.name,
        "تاریخ درخواست": base.createdAt,
        "نام هدیه": "",
        "تعداد هدیه": "",
        [addressOrIbanHeader]: base.addressOrIban,
        "شماره موبایل": base.phone,
        وضعیت: base.status,
        "مجموع تعداد سکه ها": "",
      };

      if (isCategory1) {
        emptyRow["تبدیل سکه به ریال"] = "";
      }

      return [emptyRow];
    });

    // ساخت هدرها به صورت داینامیک
    const headers = [
      "شناسه",
      "نام",
      "تاریخ درخواست",
      "نام هدیه",
      "تعداد هدیه",
      addressOrIbanHeader,
      "شماره موبایل",
      "وضعیت",
      "مجموع تعداد سکه ها",
    ];

    if (isCategory1) {
      headers.push("تبدیل سکه به ریال");
    }

    const ws = XLSX.utils.json_to_sheet(rows, {
      header: headers,
    });

    // عرض ستون‌ها (اگر ستون جدید داریم، براش عرض هم بگذار)
    ws["!cols"] = [
      { wch: 15 }, // شناسه
      { wch: 25 }, // نام
      { wch: 22 }, // تاریخ درخواست
      { wch: 40 }, // نام هدیه
      { wch: 12 }, // تعداد هدیه
      { wch: 45 }, // آدرس / دسته / شبا
      { wch: 15 }, // شماره موبایل
      { wch: 14 }, // وضعیت
      { wch: 18 }, // تعداد سکه
    ];

    if (isCategory1) {
      ws["!cols"].push({ wch: 22 }); // تبدیل سکه به ریال
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");

    XLSX.writeFile(
      wb,
      `orders_${new Date()
        .toISOString()
        .slice(0, 16)
        .replace(/[:T]/g, "-")}.xlsx`
    );
  };

  const handleRejectSubmit = async () => {
    if (isBulkReject) {
      if (!selectedOrdersList.length) return;

      await CartReject({
        orderIds: selectedOrdersList,
        reason: messageContent || "",
      });

      setSelectedOrders([]);
      setSelectedOrdersList([]);
    } else if (selectedRowData) {
      await CartReject({
        orderIds: [selectedRowData.id],
        reason: messageContent || "",
      });
    }

    refetch();
    setModalDontSend(false);
    setMessageContent("");
    setSelectedRowData(null);
    setIsBulkReject(false);
  };

  return (
    <div className="custom-container">
      {userCampaign?.items == undefined && <Loading />}
      <div className="card mt-2">
        <h5>سفارشات </h5>
        <div className="background-dataTable">
          <div className="row mt-2">
            <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2">
              <TextField
                style={{ height: "40px" }}
                value={tempFilters.OrderId}
                label={"شناسه"}
                onChange={(e) =>
                  setTempFilters({ ...tempFilters, OrderId: e.target.value })
                }
              />
            </div>
            <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2">
              <TextField
                style={{ height: "40px" }}
                value={tempFilters.Name}
                label={"نام کاربر"}
                onChange={(e) =>
                  setTempFilters({ ...tempFilters, Name: e.target.value })
                }
              />
            </div>
            <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2">
              <TextField
                style={{ height: "40px" }}
                value={tempFilters.PhoneNumber}
                label={"شماره تلفن کاربر"}
                onChange={(e) =>
                  setTempFilters({
                    ...tempFilters,
                    PhoneNumber: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2">
              <SelectCustom
                name="ProductCategoryType"
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={listItemType}
                value={
                  listItemType.find(
                    (item) => item.value === tempFilters.ProductCategoryType
                  ) || null
                }
                onChange={(e) => {
                  setTempFilters({
                    ...tempFilters,
                    ProductCategoryType: e ? e.value : null,
                  });
                }}
              />
            </div>
            <div className="col-12 col-xl-3 col-md-5 mt-2">
              <SelectCustom
                name="Status"
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={listState}
                value={
                  listState.find((item) => item.value === tempFilters.Status) ||
                  null
                }
                onChange={(e) => {
                  setTempFilters({
                    ...tempFilters,
                    Status: e ? e.value : null,
                  });
                }}
              />
            </div>
            <div className="col-12 col-xl-3 col-md-5 mt-2">
              <SelectCustom
                name="OrderBy"
                placeholder="مرتب کردن بر اساس"
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={orderByOptions}
                value={
                  orderByOptions.find(
                    (item) => item.value === tempFilters.OrderBy
                  ) || null
                }
                onChange={(e) => {
                  setTempFilters({
                    ...tempFilters,
                    OrderBy: e ? e.value : null,
                  });
                }}
              />
            </div>
            {tempFilters.OrderBy && (
              <div className="col-12 col-xl-3 col-md-5 mt-2">
                <SelectCustom
                  name="IsAscending"
                  placeholder=" مرتب سازی بر اساس"
                  isClearable={true}
                  isSearchable={false}
                  unstyled={true}
                  options={sortOrderBy}
                  value={
                    sortOrderBy.find(
                      (item) => item.value === tempFilters.IsAscending
                    ) || null
                  }
                  onChange={(e) => {
                    setTempFilters({
                      ...tempFilters,
                      IsAscending: e ? e.value : null,
                    });
                  }}
                />
              </div>
            )}
            <div className="col-12 col-xl-3 col-md-5 mt-2">
              <div
                style={{
                  display: "inline-block",
                  position: "relative",
                }}
              >
                <DatePicker
                  containerStyle={{
                    height: "40px",
                    borderRadius: "8px",
                    color: "#4b5563",
                    fontSize: "1rem",
                    borderColor: "#c8c8c8",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    width: "210px",
                    display: "flex",
                    paddingRight: "10px",
                    alignItems: "center",
                    boxShadow: "none",
                    backgroundColor: "#1f1f1f",
                  }}
                  inputClass="no-outline"
                  placeholder="تاریخ را انتخاب کنید"
                  style={{ borderRadius: "8px", border: "none" }}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom"
                  range
                  rangeHover
                  value={
                    tempFilters.From && tempFilters.To
                      ? [
                          new DateObject({
                            calendar: persian,
                            date: tempFilters.From,
                          }),
                          new DateObject({
                            calendar: persian,
                            date: tempFilters.To,
                          }),
                        ]
                      : ["", ""]
                  }
                  onChange={(e) => {
                    if (e.length === 2) {
                      handleChange("From", GetUnixDate(e[0]));
                      handleChange("To", GetUnixDate(e[1], true));
                    }
                  }}
                  clearable
                  format="YYYY/MM/DD"
                />
                <CloseRedIconSvg
                  onClick={() => {
                    setTempFilters({
                      ...tempFilters,
                      From: null,
                      To: null,
                    });
                  }}
                  style={{
                    cursor: "pointer",
                    width: "16px",
                    height: "16px",
                    position: "absolute",
                    left: "6px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 100,
                  }}
                />
              </div>
            </div>
            <div className="col-6 col-xl-2 col-md-5 d-flex align-items-end  mt-2">
              <button
                style={{
                  color: "#ffff",
                  background: "#86a0ff",
                  border: "0px",
                  width: "108px",
                  height: "39px",
                  borderRadius: "8px",
                  padding: "2px",
                }}
                onClick={handleSearch}
              >
                جستجو
              </button>
            </div>
          </div>

          <ResponsiveDataList
            data={userCampaign?.items}
            columns={columnsWithoutActions}
            itemTemplate={itemTemplate}
            dataViewHeader={<></>}
            className="farsi-monospace-digit campaign-table"
            rows={pageSizeState}
            rowsPerPageOptions={[10, 14, 20, 30, 50, 100]}
            pageNumber={filters.pageNumber}
            totalCount={userCampaign?.totalCount}
            onPageChange={({ pageNumber: newPage, pageSize: newRows }) => {
              const newFilters = {
                ...filters,
                pageNumber: newPage,
                pageSize: newRows,
              };
              setFilters(newFilters);
              setPageSizeState(newRows);
              refetch();
            }}
            typeFilter={true}
            onSelectionChange={(e) => {
              setSelectedOrders(e.value);
              setSelectedOrdersList(e.value.map((u) => u.id));
            }}
            selection={selectedOrders}
            enableSelection={true}
            dataKey="id"
            onRowClick={(row) => {
              openDetails(row);
            }}
          />
        </div>
      </div>

      <div className="fixed-footer-buttons">
        {userCampaign?.items?.length > 0 && (
          <>
            <button className="button2" onClick={exportToExcel}>
              دانلود اکسل
            </button>
            {selectedOrdersList.length > 0 && (
              <>
                <button className="button2" onClick={handleBulkApprove}>
                  تایید انتخاب‌ها
                </button>
                <button className="button2" onClick={handleBulkReject}>
                  رد انتخاب‌ها
                </button>
              </>
            )}
          </>
        )}
      </div>

      <Dialog
        header="علت عدم تایید"
        visible={modalDontSend}
        style={{ width: "20vw", height: "13vw" }}
        maximizable
        modal
        contentStyle={{ height: "300px" }}
        onHide={() => {
          setModalDontSend(false);
          setMessageContent("");
          setSelectedRowData(null);
          setIsBulkReject(false);
        }}
        className="farsi-monospace-digit custom-dialog"
      >
        <div className="row justify-content-center mx-4 ">
          <TextareaField
            value={messageContent}
            classNameBox={"mt-4"}
            label={"متن پیام"}
            onChange={(e) => setMessageContent(e.target.value)}
          />
          <button
            style={{
              marginTop: "4px",
              color: "#ffff",
              background: "#fd4c4c",
              border: "0px",
              width: "68px",
              borderRadius: "8px",
              padding: "2px",
            }}
            onClick={handleRejectSubmit}
          >
            ارسال
          </button>
        </div>
      </Dialog>

      <Dialog
        header={`جزئیات سفارش ${selectedOrder?.id ?? ""}`}
        visible={detailsOpen}
        style={{ width: "56rem", maxWidth: "96vw" }}
        modal
        onHide={closeDetails}
        className="farsi-monospace-digit custom-dialog"
        contentStyle={{ padding: 0, direction: "rtl" }}
      >
        {selectedOrder && (
          <div
            style={{ display: "flex", flexDirection: "column", minHeight: 420 }}
          >
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "2px solid #313946",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2,1fr)",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    background: "#1a1f25",
                    borderRadius: 12,
                    padding: 12,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div style={{ fontSize: 13, color: "#6b7280" }}>
                      کاربر:{" "}
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {selectedOrder?.userInfo?.name}
                    </div>
                  </div>
                  <div style={{ marginTop: 6, fontSize: 13 }}>
                    موبایل: {selectedOrder?.userInfo?.phoneNumber}
                  </div>
                </div>

                <div
                  style={{
                    background: "#1a1f25",
                    borderRadius: 12,
                    padding: 12,
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ fontSize: 13, color: "#6b7280" }}>
                      تاریخ:{" "}
                    </div>
                    <div>
                      <PersianDate date={selectedOrder.creationTime} />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ fontSize: 13, color: "#6b7280" }}>
                      وضعیت:{" "}
                    </div>
                    <span>{statusBadge(selectedOrder.status)}</span>
                  </div>
                  <div>
                    <div style={{ fontSize: 13, color: "#6b7280" }}>
                      مبلغ سکه
                    </div>
                    <div className="farsi-monospace-digit">
                      {formatNumber(selectedOrder.totalAmount)}
                    </div>
                  </div>
                  {filters?.ProductCategoryType !== 3 && (
                    <div>
                      <div style={{ fontSize: 13, color: "#6b7280" }}>
                        شبای کاربر
                      </div>
                      <div style={{ direction: "ltr" }}>
                        {selectedOrder.ibanCode ?? "-"}
                      </div>
                    </div>
                  )}
                </div>

                {(filters?.ProductCategoryType === 3 ||
                  filters?.ProductCategoryType == null) && (
                  <div
                    style={{
                      gridColumn: "1 / -1",
                      border: "1px solid #1a1f25c9",
                      borderRadius: 12,
                      padding: 12,
                    }}
                  >
                    <div style={{ fontSize: 13, color: "#6b7280" }}>آدرس</div>
                    <div style={{ marginTop: 4 }}>
                      {formatAddress(selectedOrder.address)}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* اقلام سفارش */}
            <div style={{ padding: 20 }}>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>
                اقلام سفارش
              </div>

              <div
                style={{
                  border: "1px solid #1a1f25",
                  borderRadius: 12,
                  overflow: "hidden",
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "72px 1fr 100px 140px",
                    gap: 0,
                    background: "#1a1f25",
                    padding: "10px 12px",
                    fontWeight: 600,
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                  }}
                >
                  <div>تصویر</div>
                  <div>نام کالا</div>
                  <div>تعداد</div>
                  <div>قیمت</div>
                </div>

                <div
                  style={{
                    maxHeight: "40vh",
                    overflowY: "auto",
                    overscrollBehavior: "contain",
                    direction: "rtl",
                  }}
                >
                  {selectedOrder.items?.map((it) => (
                    <div
                      key={it.productId}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "72px 1fr 100px 140px",
                        gap: 0,
                        alignItems: "center",
                        padding: "10px 12px",
                        background: "#2a323d",
                      }}
                    >
                      <div>
                        <img
                          src={it.pictureUrl}
                          alt=""
                          loading="lazy"
                          style={{
                            width: 48,
                            height: 48,
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                        />
                      </div>
                      <div style={{ lineHeight: 1.5 }}>{it.productName}</div>
                      <div className="farsi-monospace-digit">
                        {formatNumber(it.quantity)}
                      </div>
                      <div className="farsi-monospace-digit">
                        {formatNumber(it.purchasedPrice)}
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "72px 1fr 100px 140px",
                    padding: "10px 12px",
                    background: "#1a1f25",
                    fontWeight: 600,
                    position: "sticky",
                    bottom: 0,
                    zIndex: 1,
                  }}
                >
                  <div />
                  <div style={{ textAlign: "left" }}>جمع سفارش</div>
                  <div />
                  <div className="farsi-monospace-digit">
                    {formatNumber(selectedOrder.totalAmount)}
                  </div>
                </div>
              </div>
            </div>

            {/* اکشن‌های پایین دیالوگ */}
            <div
              style={{
                borderTop: "2px solid #313946",
                padding: 12,
                position: "sticky",
                bottom: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {(filters?.Status === 0 || filters?.Status == null) && (
                  <button
                    style={{
                      color: "#fff",
                      background: "rgba(39,138,60,.92)",
                      border: 0,
                      minWidth: 120,
                      height: 40,
                      borderRadius: 10,
                    }}
                    onClick={() => approveOrder(selectedOrder.id)}
                  >
                    تایید کردن
                  </button>
                )}

                {(filters?.Status === 0 || filters?.Status == null) && (
                  <>
                    <div style={{ flex: 1, minWidth: 240 }}>
                      <TextareaField
                        value={rejectReason}
                        classNameBox={"w-100"}
                        label={"علت عدم واریز (اختیاری)"}
                        onChange={(e) => setRejectReason(e.target.value)}
                      />
                    </div>
                    <button
                      style={{
                        color: "#fff",
                        background: "rgba(253,76,76,.92)",
                        border: 0,
                        minWidth: 120,
                        height: 40,
                        borderRadius: 10,
                      }}
                      onClick={() =>
                        rejectOrder(selectedOrder.id, rejectReason)
                      }
                    >
                      تایید نکردن
                    </button>
                  </>
                )}
                <div style={{ marginInlineStart: "auto" }}>
                  <button
                    style={{
                      background: "#f3f4f6",
                      color: "#111827",
                      border: "1px solid #e5e7eb",
                      minWidth: 100,
                      height: 40,
                      borderRadius: 10,
                    }}
                    onClick={closeDetails}
                  >
                    بستن
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Dialog>
    </div>
  );
};

export default Campaign;
